/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Resolved security level: explicit signer override falling back to template config default. BASIC includes DRAW; ADVANCED is strong methods only.
 */
export enum DocumentSigningSecurityLevel {
    BASIC = 'BASIC',
    ADVANCED = 'ADVANCED',
}
